import { useVoicePlayerContext } from "@sendbird/uikit-react/VoicePlayer/context";
import { useVoiceRecorderContext } from "@sendbird/uikit-react/VoiceRecorder/context";

import { useNotificationMuteActivity } from "@/lib/hooks/conversations/use-notification-mute-activity";
import { useSbCalls } from "@/lib/sendbird-calls";

export function NotificationMuteSendbirdBridge() {
  const { isRecordable } = useVoiceRecorderContext();
  const { voicePlayerStore } = useVoicePlayerContext();

  const isPlaying = Object.values(voicePlayerStore.audioStorage).some(
    (unit) => unit.playingStatus === "PLAYING",
  );

  useNotificationMuteActivity(isRecordable, "sb-voice-recorder");
  useNotificationMuteActivity(isPlaying, "sb-voice-player");

  return null;
}

export function NotificationMuteCallBridge() {
  const { calls, rooms } = useSbCalls();

  const onCall =
    rooms.some((room) => !!room.localParticipant) ||
    calls.some((call) => call.callState !== "ended");

  useNotificationMuteActivity(onCall, "sb-call");

  return null;
}
